import { useQuery } from '@tanstack/react-query';
import { serviceDesksApi, type ServiceDeskWithRequestTypes } from '../api/serviceDesksApi';

const serviceDesksWithRequestTypesQueryKey = ['service-desks', 'with-request-types'];

/** The desk + request type pairs the quota screens pick a scope from. */
export const useServiceDesksWithRequestTypes = (enabled = true) => {
  const { data, isLoading, error } = useQuery<ServiceDeskWithRequestTypes[]>({
    queryKey: serviceDesksWithRequestTypesQueryKey,
    queryFn: serviceDesksApi.withRequestTypes,
    enabled,
    staleTime: 5 * 60 * 1000,
  });

  return { serviceDesks: data ?? [], isLoading, error: error as Error | null };
};
